import { render, staticRenderFns } from "./pubShortVideo.vue?vue&type=template&id=54c184a4&scoped=true"
import script from "./pubShortVideo.vue?vue&type=script&lang=js"
export * from "./pubShortVideo.vue?vue&type=script&lang=js"
import style0 from "./pubShortVideo.vue?vue&type=style&index=0&id=54c184a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c184a4",
  null
  
)

export default component.exports